import { render, staticRenderFns } from "./KuaishouTextAd.vue?vue&type=template&id=4f38b6ac&scoped=true&"
import script from "./KuaishouTextAd.vue?vue&type=script&lang=js&"
export * from "./KuaishouTextAd.vue?vue&type=script&lang=js&"
import style0 from "./KuaishouTextAd.vue?vue&type=style&index=0&id=4f38b6ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38b6ac",
  null
  
)

export default component.exports